/* TIENDECO · Esterilizador UV — comportamiento de la landing
   Galería, botón sticky, comparativa animada, botones que suben al título y selección de pack. */
(() => {
  /* Packs: título "ELIGE TU KIT" centrado y en mayúsculas, con más espacio entre los kits */
  if (!document.getElementById('pp-packs-css')) {
    const ps = document.createElement('style');
    ps.id = 'pp-packs-css';
    ps.textContent = 'html body .pp-product #pedido fieldset.pp-bundles{gap:20px!important}html body .pp-product #pedido fieldset.pp-bundles>legend{width:100%!important;text-align:center!important;text-transform:uppercase!important;letter-spacing:.06em!important;margin:0 0 14px!important}.pp-header a.pp-header-logo{pointer-events:none!important;cursor:default!important}';
    document.head.appendChild(ps);
  }
  /* Logo de la marca (3D AMOR) visible pero sin enlace: no lleva a ninguna página */
  document.querySelectorAll('a.pp-header-logo').forEach(a => { a.removeAttribute('href'); a.setAttribute('tabindex', '-1'); });
  /* Kit sin precio de comparación (1 unidad): agrega la insignia "Envío gratis incluido" (dato real, sin descuento inventado) */
  document.querySelectorAll('.pp-bundles .pp-bundle-price').forEach(p => {
    if (p.querySelector('.pp-save') || p.querySelector('.pp-bundle-free')) return;
    const row = document.createElement('span');
    row.className = 'pp-bundle-save-row pp-bundle-free';
    row.innerHTML = '<span class="pp-save">Envío gratis incluido</span>';
    p.appendChild(row);
  });
  if (customElements.get('pp-product-page')) return;

  class ProductPage extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      const observers = (this._observers = []);
      this.classList.add('pp-js');

      /* 1) Galería */
      const image = this.querySelector('[data-pp-main]');
      const thumbs = [...this.querySelectorAll('[data-pp-thumb]')];
      const choose = (button) => {
        if (!image || !button) return;
        image.removeAttribute('srcset');
        image.src = button.dataset.full;
        image.alt = button.dataset.alt;
        thumbs.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      };
      thumbs.forEach((button, index) => {
        button.addEventListener('click', () => choose(button), { signal });
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % thumbs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + thumbs.length) % thumbs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = thumbs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          thumbs[next].focus();
          choose(thumbs[next]);
        }, { signal });
      });

      /* 1b) Galería: deslizar con el dedo sobre la imagen principal (celular y tablet). Sin cambio automático. */
      if (image && thumbs.length > 1) {
        const current = () => Math.max(0, thumbs.findIndex(t => t.getAttribute('aria-pressed') === 'true'));
        const go = (step) => {
          const next = (current() + step + thumbs.length) % thumbs.length;
          choose(thumbs[next]);
          /* solo mueve la tira de miniaturas; no desplaza la página */
          const strip = thumbs[next].parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth) {
            strip.scrollTo({ left: thumbs[next].offsetLeft - (strip.clientWidth - thumbs[next].offsetWidth) / 2, behavior: 'smooth' });
          }
          image.classList.remove('pp-swipe-l', 'pp-swipe-r');
          void image.offsetWidth;
          image.classList.add(step > 0 ? 'pp-swipe-l' : 'pp-swipe-r');
        };
        let sx = 0, sy = 0, tracking = false;
        image.addEventListener('touchstart', e => {
          if (e.touches.length !== 1) { tracking = false; return; }
          sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
        }, { passive: true, signal });
        image.addEventListener('touchend', e => {
          if (!tracking) return;
          tracking = false;
          const t = e.changedTouches[0];
          const dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) go(dx < 0 ? 1 : -1);
        }, { passive: true, signal });
        image.addEventListener('touchcancel', () => { tracking = false; }, { passive: true, signal });
        image.addEventListener('dragstart', e => e.preventDefault(), { signal });
      }

      /* 2) Sticky: visible desde el inicio; se oculta mientras se ven los packs o el cierre */
      const sticky = this.querySelector('.pp-sticky-buy');
      const targets = [this.querySelector('#pedido'), this.querySelector('.pp-close')].filter(Boolean);
      if (sticky && targets.length && 'IntersectionObserver' in window) {
        sticky.hidden = false;
        const visibles = new Set();
        const io = new IntersectionObserver(entries => {
          entries.forEach(e => (e.isIntersecting ? visibles.add(e.target) : visibles.delete(e.target)));
          sticky.hidden = visibles.size > 0;
        });
        targets.forEach(t => io.observe(t));
        observers.push(io);
      } else if (sticky) {
        sticky.hidden = false;
      }

      /* 3) Comparativa: filas entran al aparecer */
      const board = this.querySelector('.pp-vs-board');
      if (board) {
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(entries => {
            if (entries.some(e => e.isIntersecting)) { board.classList.add('is-in'); io.disconnect(); }
          }, { threshold: 0.2 });
          io.observe(board);
          observers.push(io);
        } else {
          board.classList.add('is-in');
        }
      }

      /* 4) Todos los botones "Realizar pedido" suben al título, bajo el header fijo */
      const title = this.querySelector('#producto-titulo');
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href="#producto-titulo"]');
        if (!link || !title) return;
        event.preventDefault();
        const header = this.querySelector('.pp-header');
        const offset = (header ? header.offsetHeight : 0) + 12;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: title.getBoundingClientRect().top + window.scrollY - offset, behavior: reduce ? 'auto' : 'smooth' });
      }, { signal });

      /* 5) Packs: la variante elegida queda en el formulario (name="id") y en la URL,
            para que Releasit y el tema lean el mismo pack */
      this.querySelectorAll('.pp-bundles input[name="id"]').forEach(input => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', input.value);
            window.history.replaceState({}, '', url.toString());
          } catch (e) { /* sin cambios */ }
          input.form?.dispatchEvent(new Event('change', { bubbles: true }));
        }, { signal });
      });

      /* 6) Guarda el pack elegido para mostrarlo en la página de agradecimiento (/pages/gracias) */
      const savePack = () => {
        const input = this.querySelector('.pp-bundles input[name="id"]:checked');
        const card = input?.closest('.pp-bundle');
        if (!card) return;
        const txt = sel => (card.querySelector(sel)?.textContent || '').replace(/\s+/g, ' ').trim();
        const data = {
          item: (title?.textContent || '').replace(/\s+/g, ' ').trim(),
          pack: txt('.pp-bundle-name').replace(/ · Agotado$/, ''),
          qty: parseInt(card.dataset.pack, 10) || 1,
          total: txt('.pp-bundle-price strong'),
          variant: input.value,
          t: Date.now()
        };
        try { localStorage.setItem('tdc_last_order', JSON.stringify(data)); } catch (e) { /* sin almacenamiento */ }
      };
      savePack();
      this.addEventListener('change', event => {
        if (event.target.matches?.('.pp-bundles input[name="id"]')) savePack();
      }, { signal });
    }

    disconnectedCallback() {
      (this._observers || []).forEach(o => o.disconnect());
      this._controller?.abort();
      this._controller = null;
    }
  }

  customElements.define('pp-product-page', ProductPage);
})();
